module.exports = __webpack_public_path__ + "5d61359325d637f37234e26e975d9e75.svg";